export default __webpack_public_path__ + "static/media/project1.6f716b75.webp";